export const formatShipmentLocation = (loc) => {
  if (!loc) return 'N/A';
  const parts = [loc.city, loc.state, loc.country].filter(Boolean);
  return parts.join(', ') || 'N/A';
};

export const formatShipmentDate = (dateStr) => {
  if (!dateStr) return 'N/A';
  try {
    return new Date(dateStr).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
    });
  } catch {
    return 'N/A';
  }
};

export const formatShipmentVehicle = (vehicle) => {
  if (!vehicle) return 'Unknown Vehicle';
  return (
    [vehicle.year, vehicle.make, vehicle.model].filter(Boolean).join(' ') ||
    'Unknown Vehicle'
  );
};

// #494: for BOL-upload ocean shipments the shipment's own
// `estimated_delivery_date` is null, so the card showed "N/A" even though a
// real ETA exists — the backend already resolves it into the composite tracking
// snapshot (`metadata.tracking_composite.eta.value`, ranked/verified server-side).
// Fall back to that before giving up.
export const shipmentEtaValue = (s) =>
  s?.estimated_delivery_date ||
  s?.metadata?.tracking_composite?.eta?.value ||
  null;

// Customer-facing label only. `id` stays the full backend UUID used for routes,
// chat scope, and API calls. The card shows the first 5 characters of that id.
const CUSTOMER_SHIPMENT_ID_LENGTH = 5;

export const customerShipmentNumber = (shipment) => {
  const id = String(shipment?.id ?? shipment?._raw?.id ?? "")
    .replace(/^#/, "")
    .trim();
  if (!id) return "";
  return id.slice(0, CUSTOMER_SHIPMENT_ID_LENGTH).toUpperCase();
};

// A quote is a price check, not a shipment. The shipments list only shows
// booked shipments and later lifecycle stages.
const QUOTE_STATUSES = new Set(["quote", "quoted"]);

export const isQuoteShipment = (shipment) => {
  const raw = shipment?.status || shipment?.detailed_status || "";
  const key = String(raw)
    .toLowerCase()
    .trim()
    .replace(/[\s-]+/g, "_");
  return QUOTE_STATUSES.has(key);
};

export const normalizeShipment = (s) => ({
  id: s.id,
  number: customerShipmentNumber(s),
  vehicle: formatShipmentVehicle(s.vehicle),
  from: formatShipmentLocation(s.pickup),
  to: formatShipmentLocation(s.dropoff),
  date: formatShipmentDate(s.booking_date),
  eta: formatShipmentDate(shipmentEtaValue(s)),
  arrival: formatShipmentDate(s.actual_delivery_date),
  status: s.status,
  _raw: s,
});
